export enum InboxTypeEnum {
  OpenAll = 'open_all',
  OpenAllAssigned = 'open_all_assigned',
  OpenAllUnassigned = 'open_all_unassigned',
  OpenByAI = 'open_by_ai',
  OpenUnassigned = 'open_unassigned',
  OpenByMe = 'open_by_me',
  OpenByOther = 'open_by_other',
  ResolvedAll = 'resolved_all',
  AssumedResolvedByAI = 'assumed_resolved_by_ai',
  // Do not use ConfirmedResolvedByAI - not yet implemented on backend
  ConfirmedResolvedByAI = 'confirmed_resolved_by_ai',
  ResolvedByHuman = 'resolved_by_human',
}

// TODO add path from index.router.tsx
export const IndexPath = {
  acceptInvitation: 'accept-invitation',
  gettingStarted: 'getting-started',
  aiPreview: 'ai-preview',
  inbox: {
    root: 'conversation',
    openAll: `?type=${InboxTypeEnum.OpenAll.toString()}`,
    openAllAssigned: `?type=${InboxTypeEnum.OpenAllAssigned.toString()}`,
    openAllUnassigned: `?type=${InboxTypeEnum.OpenAllUnassigned.toString()}`,
    openByAI: `?type=${InboxTypeEnum.OpenByAI.toString()}`,
    openUnassigned: `?type=${InboxTypeEnum.OpenUnassigned.toString()}`,
    openByMe: `?type=${InboxTypeEnum.OpenByMe.toString()}`,
    openByOther: `?type=${InboxTypeEnum.OpenByOther.toString()}`,
    resolvedAll: `?type=${InboxTypeEnum.ResolvedAll.toString()}`,
    assumedResolvedByAI: `?type=${InboxTypeEnum.AssumedResolvedByAI.toString()}`,
    resolvedByHuman: `?type=${InboxTypeEnum.ResolvedByHuman.toString()}`,
  },
  inboxBackwardCompatibilityConversation: 'conversations/:id',
  insights: 'insights',
  identity: 'identity',
  knowledgeBase: {
    root: 'knowledge-base',
    article: 'knowledge-base/articles/:id',
    create: 'articles/:articleId',
    sony: 'knowledge-base/sony',
    sonyDocument: 'knowledge-base/sony/documents/:externalId',
  },
  subscription: 'subscription',
  website: 'website',
  chatPage: 'chat-page',
  channels: 'channels',
  actions: 'actions',
  simulation: 'simulation',
  settings: 'settings',
  user: {
    accountSettings: 'account-settings',
    profile: 'user/profile',
  },
};

export enum SettingsTabsEnum {
  Account = 'account',
  Organization = 'organization',
  Billing = 'billing',
}
